const benefitCalculator = {
  BENEFIT_CALCULATOR_LINK: `https://benefits-calculator.turn2us.org.uk/`,
  BENEFIT_CALCULATOR_LABEL: `Benefit Calculator`,
};

export default benefitCalculator;
